// Identity-routed root: agency owner → AgencyView, sub-account user → CustomerView.
import { useAuth } from './contexts/AuthProvider';
import AgencyView from './pages/AgencyView';
import CustomerView from './pages/CustomerView';

export default function App() {
  const { loading, error, me } = useAuth();

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center text-slate-500">
        <div className="flex items-center gap-3">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-slate-300 border-t-brand" />
          Loading…
        </div>
      </div>
    );
  }

  if (error || !me) {
    return (
      <div className="grid min-h-screen place-items-center p-6">
        <div className="max-w-md rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-slate-900">Not signed in</h1>
          <p className="mt-2 text-sm text-slate-500">
            This app runs inside HighLevel. For local preview, append{' '}
            <code className="rounded bg-slate-100 px-1 py-0.5 text-brand">?as=agency</code> or{' '}
            <code className="rounded bg-slate-100 px-1 py-0.5 text-brand">?as=customer</code> to the URL.
          </p>
          {error && <p className="mt-3 text-xs text-rose-500">{error}</p>}
        </div>
      </div>
    );
  }

  return me.context === 'agency' ? <AgencyView me={me} /> : <CustomerView me={me} />;
}
